export default __webpack_public_path__ + "static/media/phantom-icon-purple.c0903752.svg";